/**
 * "What's new" entries, newest first.
 *
 * This is the default way to tell staff about a change they can see. A spotlight
 * (announcements.js) is an extra, only for the one change that affects their work now.
 * Run /spotlight <feature> to decide. See /docs/feature-spotlight-system.md.
 *
 * @property {string} id - Unique, snake_case, 54 characters or fewer. Never rename or reuse
 *                         an id: seen state is stored against it.
 * @property {string} date - The day it reached production, YYYY-MM-DD.
 * @property {string} title - Short headline in staff words.
 * @property {string} text - One or two sentences: what changed and what to do.
 * @property {object} [link] - "Show me": { to, featureId }. Opens `to`, and shows the
 *                             spotlight for `featureId` if that announcement is live.
 */

export const WHATS_NEW = [
  {
    id: 'missed_call_text',
    date: '2026-10-15',
    title: 'Text callers after a missed call',
    text: 'Dentara can text a caller when a call is missed. It is off until an admin turns it on for a location in Automatic texts on the Templates page, where admins can also change the words.',
    link: { to: '/templates' },
  },
  {
    id: 'texts_waiting_for_reply',
    date: '2026-10-14',
    title: 'See who texted you',
    text: 'The top of the dashboard now counts patients whose last text nobody has answered. Texting back, or tapping Contacted, takes a patient off the list.',
    link: { to: '/home', featureId: 'waiting-replies-banner' },
  },
  {
    id: 'shorter_ai_summaries',
    date: '2026-09-15',
    title: 'Shorter AI summaries',
    text: 'The AI summary on each lead now covers the whole history, and is short enough to read during a call.',
  },
  {
    id: 'fewer_popup_tips',
    date: '2026-09-15',
    title: 'Fewer pop-up tips',
    text: "Tips about new features now show once, at most one a day, and never block the screen. You'll find every change here.",
  },
  {
    id: 'stay_signed_in',
    date: '2026-09-12',
    title: 'You stay signed in',
    text: 'Dentara no longer signs you out every hour.',
  },
  {
    id: 'next_action',
    date: '2026-09-09',
    title: 'Next action on every lead',
    text: 'Our AI suggests what each lead needs next: a call back, a booking link or an insurance check. Pick a different one if you disagree.',
  },
  {
    id: 'dashboard_worklist',
    date: '2026-09-09',
    title: 'Your dashboard starts with the work',
    text: 'The top of the dashboard counts the leads that need a call back, a booking link or an insurance check. Click a number to open those leads.',
    link: { to: '/home' },
  },
];
